import React, { Ref } from "react";
import classNames from "classnames";

import { StrainRelative } from "@/custom-types/StrainV2";

import StrainLineageLink from "./StrainLineageLink";

type Props = {
  childRef: Ref<HTMLDivElement>;
  child: StrainRelative;
  parentalClassExtension: "no-parents" | "two-parents" | "single-parent";
};

const StrainLineageSingleChild = ({
  childRef,
  child,
  parentalClassExtension,
}: Props) => (
  <div
    className={classNames("col-[1/7]", {
      "row-[4/6]": parentalClassExtension === "no-parents",
      "row-[6/8]": parentalClassExtension === "two-parents",
      "row-[7/9]": parentalClassExtension === "single-parent",
    })}
    ref={childRef}
  >
    <StrainLineageLink
      strain={child}
      altText="Strain child"
      parentOrChild="child"
    />
  </div>
);

export default StrainLineageSingleChild;
